var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PagesCountAreaReport',{attrs:{"items":_vm.items,"pfilters":_vm.$route.params.filters,"region-id":_vm.$route.params.regionId},on:{"updated":_vm.onUpdate}})
}
var staticRenderFns = []

export { render, staticRenderFns }